import React  from 'react';
import PropTypes from 'prop-types';
import by from 'thenby';
import { SearchSelect } from 'ui-kit';

export const PLACEHOLDER = 'Select stage...';
export const NO_RESULTS_PLACEHOLDER = 'No stage found.';

const toOption = ({ id, name }) => ({
    value: id,
    label: name,
});

const SelectStage = ({
    placeholder = PLACEHOLDER,
    noResultsPlaceholder = NO_RESULTS_PLACEHOLDER,
    disabled = false,
    value,
    stages = [],
    onChange = () => {}
}) => (
    <SearchSelect
        placeholder={placeholder}
        noResultsPlaceholder={noResultsPlaceholder}
        value={value}
        isDisabled={disabled}
        options={stages.sort(by('name')).map(toOption)}
        onChange={onChange}
    />
);

SelectStage.propTypes = {
    placeholder: PropTypes.string,
    noResultsPlaceholder: PropTypes.string,
    disabled: PropTypes.bool,
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    stages: PropTypes.array,
    onChange: PropTypes.func,
};

export default SelectStage;
